import { collection, doc, onSnapshot, query, setDoc, Unsubscribe } from 'firebase/firestore'

import { ChatTyping } from 'Types'

import { authState } from '../auth'

import { chatsCollection } from './chats'

const typingCollection = (chatId: string) => collection(chatsCollection(), chatId, 'typing')

type OnTyping = (typings: ChatTyping[]) => void
export const subscribeOnTyping = (chatId: string, onTyping: OnTyping): Unsubscribe => {
  const typingsQuery = query(typingCollection(chatId))

  return onSnapshot(typingsQuery, (snapshot) => {
    const typings = snapshot.docs.map((doc) => ({ memberId: doc.id, ...doc.data() } as ChatTyping))
    onTyping(typings)
  })
}

export const setTyping = (chatId: string, timestamp = new Date()): Promise<void> => {
  const typingRef = doc(typingCollection(chatId), authState.uid)
  return setDoc(typingRef, { timestamp }, { merge: true })
}
